<template>
  <header
    :class="[
      'header-area bg-white text-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky },
      { fullScreen: stateStoreInstance.isFullScreen }
    ]"
    id="header"
  >
    <!-- `col-auto` + `col` mantêm o header numa ÚNICA linha abaixo de md: o hamburger ocupa só o
         que precisa à esquerda e as ações tomam o resto, alinhadas à direita. Antes as duas
         colunas eram full-width no mobile (sem prefixo de breakpoint só em `md`), então
         empilhavam em duas linhas, ambas centralizadas — era o dobro de altura de header por
         nada. A partir de md volta a proporção original do tema. -->
    <div class="row align-items-center">
      <div class="col-auto col-md-6 col-lg-5 col-xl-4">
        <div class="header-left-side justify-content-start d-flex align-items-center">
          <button
            class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
            id="header-burger-menu"
            type="button"
            aria-controls="sidebar-area"
            :aria-expanded="stateStoreInstance.sidebarExpandido"
            :aria-label="
              stateStoreInstance.sidebarExpandido ? $t('Recolher menu') : $t('Expandir menu')
            "
            @click="stateStoreInstance.onChange"
          >
            <i class="flaticon-menu-3"></i>
          </button>
        </div>
      </div>
      <div class="col col-md-6 col-lg-7 col-xl-8">
        <div class="header-right-side d-flex align-items-center justify-content-end">
          <LightDarkSwtichBtn />

          <!-- Melhoria que ninguém descobre não melhorou nada. O pontinho fica até a
               pessoa abrir, e volta quando houver uma leva nova de novidades. -->
          <button
            type="button"
            class="novidades-btn bg-transparent border-0 p-0 transition lh-1 position-relative"
            :title="temNovidade ? 'Novidades do sistema (não lidas)' : 'Novidades do sistema'"
            aria-label="Novidades do sistema"
            @click="abrirNovidades()"
          >
            <i class="ph ph-gift"></i>
            <span
              v-if="temNovidade"
              class="novidades-aviso position-absolute rounded-circle bg-danger d-inline-block"
            >
              <span class="visually-hidden">Há novidades não lidas</span>
            </span>
          </button>

          <!-- O sistema tem atalhos de teclado desde sempre, mas nada na tela dizia isso.
               Este botão é a única porta visível para a lista. -->
          <button
            type="button"
            class="atalhos-btn bg-transparent border-0 p-0 transition lh-1"
            title="Atalhos do teclado (Alt + F1)"
            aria-label="Atalhos do teclado"
            @click="abrirAtalhos()"
          >
            <i class="ph ph-keyboard"></i>
          </button>

          <NovidadesModal ref="novidadesModal" />
          <div v-if="IsGranted('colaborador_prana')"  class="dropdown apps-dropdown">
            <button
              class="dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-dashboard"></i>
            </button>
            <div class="dropdown-menu pb-0 rounded-0 bg-white border-0 start-auto end-0">
              <div class="title d-flex align-items-center justify-content-between">
                <span class="text-black fw-bold">Apps & Social</span>
              </div>
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div class="icon rounded-circle position-absolute text-center overflow-hidden">
                    <img
                      src="../../../assets/images/icon/conexos_icon.png"
                      class="p-0 m-0"
                      alt="Conexos"
                    />
                  </div>
                  Conexos
                  <a
                    href="https://pranacomex.conexos.cloud/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
              </ul>
            </div>
          </div>

          <main-notification />
          <div class="dropdown profile-dropdown">
            <button
              class="dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                v-if="GetProfileImage()"
                :src="GetProfileImage()"
                class="rounded rounded-circle"
                width="37"
                height="37"
                alt="admin"
              />
              <span
                v-else
                id="defaultProfileImage"
                class="rounded rounded-circle defaultProfileBackground p-2 text-white"
              >
              {{Initials()}}
              </span>
              <span class="title d-none d-lg-block ms-10 ms-lg-15">
                <span class="d-block fw-bold mb-5 mb-md-8">{{ Name() }}</span>

                <span class="text-body-emphasis fw-semibold fs-13"
                  >{{ Cargo() }}
                </span>
              </span>
            </button>
            <div class="dropdown-menu rounded-0 bg-white border-0 start-auto end-0">
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li
                  class="text-body-secondary fw-semibold transition position-relative"
                  @click="LogOut()"
                >
                  <i class="flaticon-logout"></i>
                  Sair
                  <router-link
                    to="/"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
                <!-- A primeira pergunta de qualquer atendimento é "qual versão você está
                     usando?", e até aqui não havia resposta possível sem abrir o DevTools.
                     F e B são curtos de propósito, para caberem sem esticar o menu; o
                     leitor de tela ouve a palavra inteira. -->
                <li class="versao-em-uso text-body-secondary fs-13 border-top">
                  <span class="d-block">
                    <span aria-hidden="true">F:</span>
                    <span class="visually-hidden">Frontend:</span>
                    {{ versaoEmUso }}
                  </span>
                  <!-- Só aparece quando o backend responde: a rota é nova e pode não estar
                       no ar em todos os ambientes. -->
<!--                  <span v-if="versaoBackend" class="d-block">-->
<!--                    <span aria-hidden="true">B:</span>-->
<!--                    <span class="visually-hidden">Backend:</span>-->
<!--                    {{ versaoBackend }}-->
<!--                  </span>-->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { inject, ref, onMounted, onBeforeUnmount } from 'vue'
import LightDarkSwtichBtn from './LightDarkSwtichBtn.vue'
import stateStore from '@/utils/store'
import KeycloakService from '@/security/KeycloakService'
import MainNotification from '@/components/layouts/Default/MainNotification.vue'
import { useNovaVersao } from '@/composables/useNovaVersao.js'
// import { useVersaoBackend } from '@/composables/useVersaoBackend.js'
import { useNovidades } from '@/composables/useNovidades.js'
import NovidadesModal from '@/components/common/NovidadesModal.vue'


const { versaoEmUso } = useNovaVersao()
// const { versaoBackend } = useVersaoBackend()
const { temNovidade, marcarComoLidas } = useNovidades()

const novidadesModal = ref(null)

const abrirNovidades = () => {
  novidadesModal.value?.open()
  // Marca ao abrir, não ao fechar: quem abriu e desistiu de ler já sabe que existe
  marcarComoLidas()
}

const registerShortcut = inject('registerShortcut', null)
const unregisterShortcut = inject('unregisterShortcut', null)

const ATALHO_MENU = 'Alt + M'

onMounted(() => {
  // Recolher o menu devolve largura à listagem, que é onde falta espaço
  registerShortcut?.(ATALHO_MENU, () => stateStoreInstance.onChange(), 'Recolher/expandir o menu', 'Geral')
})

onBeforeUnmount(() => unregisterShortcut?.(ATALHO_MENU))

const stateStoreInstance = stateStore
const isSticky = ref(false)
const API_URL = import.meta.env.VITE_API_URL;

// Fornecido pelo App.vue, que é quem monta o ShortcutManager
const abrirAjudaDeAtalhos = inject('abrirAjudaDeAtalhos', null)

const abrirAtalhos = () => abrirAjudaDeAtalhos?.()

onMounted(() => {
  window.addEventListener('scroll', () => {
    let scrollPos = window.scrollY
    isSticky.value = scrollPos >= 100
  })
})

function Name() {
  return KeycloakService.GetName()
}

function Initials() {
  return KeycloakService.GetInitials();
}

function Cargo() {
  return KeycloakService.GetCargo()
}

function LogOut() {
  return KeycloakService.CallLogOut()
}

function ImageProfile() {
  return KeycloakService.GetImageProfile()
}


const IsGranted = (role) => {
  if (Array.isArray(role)) {
    return role.some(r => KeycloakService.IsGranted(r));
  }

  return KeycloakService.IsGranted(role)
}


const GetProfileImage = () => {
  const url = ImageProfile();
  if (url === null || url === '' || url === undefined) {
    return;
  }
  return `${API_URL}/api/arquivo/download/public/${url}`;
}
</script>

<style>
.defaultProfileBackground {
  background-color: #00263d
}

/* Informação de referência, não uma ação: sem o hover e o cursor dos outros itens do menu */
.versao-em-uso {
  padding: 10px 20px;
  cursor: default;
  pointer-events: none;
}

/* Mesmo tamanho e mesma margem dos outros ícones do cabeçalho */
.atalhos-btn,
.novidades-btn {
  margin-left: 15px;
  margin-right: 15px;
  font-size: 21px;
  /* Vale só no tema claro: no escuro quem vence é `.dark button`, que os pinta de branco */
  color: var(--text-subtle);
}

.atalhos-btn:hover,
.novidades-btn:hover {
  color: var(--splash-primary-color);
}

.atalhos-btn:focus-visible,
.novidades-btn:focus-visible {
  outline: 2px solid var(--splash-primary-color);
  outline-offset: 4px;
  border-radius: 4px;
}

/* Menor que o contador de notificações ao lado: aqui não há número para mostrar, só
   "tem coisa nova" — um ponto basta e não compete com o sino. */
.novidades-aviso {
  top: -2px;
  right: -3px;
  width: 8px;
  height: 8px;
}

</style>
